(() => {
  const money = (value) => `${Math.round(value).toLocaleString('sv-SE')} kr`;

  const initClubSavings = (root) => {
    const range = root.querySelector('[data-npc-club-range]');
    const spend = root.querySelector('[data-npc-club-spend]');
    const monthly = root.querySelector('[data-npc-club-monthly]');
    const yearly = root.querySelector('[data-npc-club-yearly]');
    if (!range || !spend || !monthly || !yearly) return;

    const update = () => {
      const value = Number(range.value);
      const saving = value * .05;
      const progress = ((value - Number(range.min)) / (Number(range.max) - Number(range.min))) * 100;
      spend.textContent = `${money(value)}/mån`;
      monthly.textContent = `${money(saving)}/mån`;
      yearly.textContent = `${money(saving * 12)}/år`;
      range.style.setProperty('--npc-club-progress', `${progress}%`);
    };

    range.addEventListener('input', update, { passive: true });
    update();
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('[data-npc-club-savings]').forEach(initClubSavings);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
